import React, { useEffect } from 'react';
import TicketNumber from '../TicketNumber';
import { useDispatch, useSelector } from 'react-redux';
import { getRaffleTicketDetail } from 'Store/actions/raffleV2/raffleTicketActions';
import { decimalFormatter } from 'Utils/decimalFormatter';
import EnvironmentManager from 'Utils/environmentManager';
import History from 'Store/history';
import Modal from 'Components/Modal';
import { closeModal } from 'Store/actions';
import { flatten } from 'lodash';
import { withMixpanel } from 'Utils/mixpanel';
import PropTypes from 'prop-types';
import { slugTurkish } from 'Utils/slugTurkish';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';

const TicketDetail = props => {
  // eslint-disable-next-line react/prop-types
  const { ticketId } = props.match.params;
  const dispatch = useDispatch();
  const { ticketDetail: { body, error }, isLoading } = useSelector(state => state.raffleV2?.raffleTickets);
  const turnBackRaffleBtnText = EnvironmentManager.getMessageText({ key: 'button_turn_back_to_raffle' }) || 'Çekilişleri Gör';
  const winningText = EnvironmentManager.getMessageText({ key: 'info_raffle_tickets_winning' }) || 'Kazanan';
  const losingText = EnvironmentManager.getMessageText({ key: 'info_raffle_tickets_losing' }) || 'Kaybeden';
  const raffleDateText = EnvironmentManager.getMessageText({ key: 'description_raffle_date' }) || 'Çekiliş Tarihi';
  const errorModalTitleText = EnvironmentManager.getMessageText({ key: 'title_raffle_ticket_purchase_generic_error' }) || 'Bilgilendirme';
  const drawPriceText = EnvironmentManager.getMessageText({ key: 'info_raffle_tickets_unit_price' }) || 'Bilet Fiyatı';
  const drawQuantityText = EnvironmentManager.getMessageText({ key: 'info_raffle_tickets_quantity' }) || 'Bilet Adedi';
  const drawTicketsTotalText = EnvironmentManager.getMessageText({ key: 'info_raffle_tickets_total' }) || 'Toplam';
  

  useEffect(() => {
    dispatch(getRaffleTicketDetail(ticketId));
  }, [ticketId]);

  useEffect(() => {
    if (!isLoading && body && body.result) {
      let results = [];

      for (let i = 0; i < Object.keys(body.result).length; i++) {
        results.push(body.result[Object.keys(body.result)[i]].barcodeStatusList);
      }

      let continuedCount = 0;
      let wonCount = 0;
      let lostCount = 0;

      flatten(results).forEach(r => {
        switch (r.status) {
          case 'PLAYED':
            continuedCount++;
            break;
          case 'WON':
            wonCount++;
            break;
          case 'LOST':
            lostCount++;
            break;
          default:
            break;
        }
      });

      const raffleStatusContinued = `Devam Eden - ${continuedCount}`;
      const mixpanelEvents = {
        'Raffle Status': continuedCount > 0 ? raffleStatusContinued : [`Kazanan - ${wonCount}`, `Kaybeden - ${lostCount}`],
        'Raffle Name': body.drawName
      };
      props.mixpanel.track('View My Tickets Detail Page in Raffles', mixpanelEvents);
    }
  }, [body && body.result]);
  

  const renderErrorModal = () => {
    return <Modal
      onClose={ () => {
        window.location.href = ('/sans-oyunlari/esya-piyangosu');
        dispatch(closeModal('raffleDetailErrorModal'));
      }
      }
      title={ errorModalTitleText }
      type="error"
      iconName="svgInfoRed"
      buttonArea={ {
        primaryButton: {
          label: turnBackRaffleBtnText,
          onClick: () => {
            window.location.href = ('/sans-oyunlari/esya-piyangosu');
            dispatch(closeModal('raffleDetailErrorModal'));
          }
        }
      } }
    >
      { EnvironmentManager.getMessageText({ key: error ? `${error?.domain}${error?.code}` : 'description_raffle_ticket_purchase_generic_error'  }) }
    </Modal>;
  };

  return (
    <>
          { props?.userAgent?.device?.type === 'mobile' && <HeaderSimplePage isDigitalGames color="ticket-detail" title={ body?.drawName } h1tag scrollY /> }
         { body && body.result && Object.keys(body.result).length > 0 && <div className="page page--raffle-ticket-detail">
           { ( props?.userAgent?.device?.type === 'desktop' || props?.userAgent?.device?.type === 'tablet')
         && <div className='ticket-detail__header'>
           <HeaderSimplePage isDigitalGames color="green" title={ body?.drawName } h1tag scrollY />
         </div>
           }
           <div className='ticket-detail__date'>{ raffleDateText } { body?.drawDate ?? '-' } </div>
           <div className="ticket-detail__card">
             { body.drawStatus === 'PASSIVE' && <div className="ticket-detail__wl-status">
               <div className="ticket-detail__wl-status--item">
                 <div className="ticket-detail__wl-status--won" />
                 { winningText }
               </div>
               <div className="ticket-detail__wl-status--item">
                 <div className="ticket-detail__wl-status--lost" />
                 { losingText }
               </div>
             </div> }
             <div className="ticket-detail__card--title"
               onClick={ () => body.drawId ? History.push(`/sans-oyunlari/esya-piyangosu/detay/${slugTurkish(body?.drawName)}?cekilis-id=${body?.drawId}`, { ticketCount: body.drawStatus === 'PASSIVE' ? body?.totalCount : null }) : null }
             >
               { body?.drawName ?? '-' }
             </div>
 
             <TicketNumber data={ body?.result } showStatusText={ body.drawStatus === 'PASSIVE' } showDate />

             <div className='ticket-detail__card--footer'>
               <div className='ticket-detail__card--footer--item'>
                 <div className='ticket-detail__card--footer--val'>{ Number.isInteger(body?.drawPrice) ? body?.drawPrice : decimalFormatter(body?.drawPrice)  ?? '-' } ₺</div>
                 <div className='ticket-detail__card--footer--desc'>{ drawPriceText }</div>
               </div>
                      
               <div className='ticket-detail__card--footer--separator' />
                      
               <div className='ticket-detail__card--footer--item'>
                 <div className='ticket-detail__card--footer--val'>{ body?.totalCount ?? '-' }</div>
                 <div className='ticket-detail__card--footer--desc'>{ drawQuantityText }</div>
               </div>
                      
               <div className='ticket-detail__card--footer--separator' />

               <div className='ticket-detail__card--footer--item'>
                 <div className='ticket-detail__card--footer--val'>{ decimalFormatter(body.totalPrice) } ₺</div>
                 <div className='ticket-detail__card--footer--desc'>{ drawTicketsTotalText }</div>
               </div>

             </div>
           </div>
         </div>
         }
      { error && !isLoading ? (
        renderErrorModal()
      ) : null }
    </>
  );
};

TicketDetail.propTypes = {
  mixpanel: PropTypes.object,
  userAgent: PropTypes.object,
};

export default withMixpanel(TicketDetail);
